import { motion } from "framer-motion";
import { steps } from "@/data/content";

export default function HowItWorks() {
  return (
    <section id="come-funziona" data-testid="how-it-works-section" className="bg-paper py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6 }}
          className="eyebrow text-brandblue mb-6"
        >
          Come funziona
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="font-serif font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-2xl leading-[1.12] mb-16 lg:mb-20"
        >
          Quattro passi verso <span className="italic text-brandblue">l'affitto senza pensieri</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((s, i) => (
            <motion.div
              key={s.num}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`step-card-${i + 1}`}
              className="relative rounded-2xl bg-white border border-ink/10 p-7 shadow-[0_4px_24px_rgba(12,27,42,0.05)] hover:shadow-[0_14px_36px_rgba(0,157,223,0.14)] hover:border-azure/40 transition-[box-shadow,border-color] duration-300"
            >
              <span className="font-serif italic text-3xl text-gold">{s.num}.</span>
              <h3 className="mt-4 font-serif font-semibold text-xl">{s.title}</h3>
              <p className="mt-3 text-sm text-ink/60 leading-relaxed">{s.desc}</p>
              {i < steps.length - 1 && (
                <span className="hidden lg:block absolute top-1/2 -right-4 w-8 h-px bg-azure/40" aria-hidden="true" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
